import { Link } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { useProjects } from "../hooks/useProjects";
import ProjectCard from "./ProjectCard";
import "./HomePage.css";

const SKILLS = [
  "Symfony",
  "Java Spring",
  "Node.js",
  "React",
  "Vue.js",
  "Angular",
  "TypeScript",
  "MySQL",
  "MongoDB",
  "PostgreSQL",
  "Docker",
  "Git",
];

function HomePage() {
  const { t } = useApp();
  const allProjects = useProjects();
  const featured = allProjects.sort(compareDate).slice(0, 3);

  return (
    <div className="home-page">
      <div>
        <span className="syn-pink">import&nbsp;</span>
        <span className="syn-white">{"{"}&nbsp;</span>
        <span className="syn-lightblue">Portfolio&nbsp;</span>
        <span className="syn-white">{"}"}&nbsp;</span>
        <span className="syn-pink">from&nbsp;</span>
        <span className="syn-orange">"Tommy-Boubaker"</span>;
      </div>

      {/* ── Comment header ─────────────────────────────────── */}
      <div className="code-comment">
        <br />
        <h1 className="syn-green">Tommy BOUBAKER</h1>
        <br />
        <span className="syn-comment">/**</span>
        <br />
        <span className="syn-comment"> * @role {t("home.role")}</span>
        <br />
        <span className="syn-comment"> * @location Lavaur, France</span>
        <br />
        <span className="syn-comment"> * @status open to work ✓</span>
        <br />
        <span className="syn-comment"> */</span>
      </div>

      {/* ── const declaration block ─────────────────────────── */}
      <div className="code-block">
        <span className="syn-orange">"{t("home.greeting")}&nbsp;{t("home.name")},&nbsp;{t("home.role")}.</span>
        <br />
        <span className="syn-orange">{t("home.pitch")}</span>
        <br />
        <br />
        <span className="syn-blue">const&nbsp;</span>
        <span className="syn-const">SKILLS&nbsp;</span>
        <span className="syn-white">=&nbsp;</span>
        <span className="syn-white">[&nbsp;</span>
        {SKILLS.map((skill, i) => (
          <span key={skill}>
            <span className="syn-orange">"{skill}"</span>
            {i < SKILLS.length - 1 && (
              <span className="syn-white">,&nbsp;</span>
            )}
          </span>
        ))}
        <span className="syn-white">&nbsp;]</span>
      </div>

      {/* ── CTA as function call ─────────────────────────────── */}
      <div className="code-block code-block--spaced">
        <div className="code-line">
          <span className="syn-comment">// {t("home.cta_projects")}</span>
        </div>

        <div className="home-cta-row">
          <Link to="/portfolio/projects" className="vsc-btn vsc-btn--primary">
            <span className="syn-yellow">viewProjects</span>
            <span style={{ color: "#d4d4d4" }}>()</span>
          </Link>
          <Link to="/portfolio/about" className="vsc-btn vsc-btn--ghost">
            <span className="syn-yellow">aboutMe</span>
            <span style={{ color: "#d4d4d4" }}>()</span>
          </Link>
          <button
            className="vsc-btn vsc-btn--primary"
            onClick={handleContactMe}
            title="mailto:tommy.boubaker@free.fr"
          >
            ContactMe()
          </button>
        </div>
      </div>

      {/* ── Featured projects as array ───────────────────────── */}
      <div className="code-block code-block--spaced">
        <div className="code-line">
          <span className="syn-blue">const&nbsp;</span>
          <span className="syn-const">featuredProjects&nbsp;</span>
          <span className="syn-white"> = [</span>
          <span className="syn-comment">
            &nbsp;// {t("home.featured_title")}
          </span>
        </div>

        <div className="home-grid">
          {featured.map((p) => (
            <ProjectCard key={p.id} project={p} />
          ))}
        </div>
        <span className="syn-white"> ]</span>
      </div>
    </div>
  );
}

function handleContactMe() {
  window.location.href = "mailto:tommy.boubaker@free.fr";
}

function compareDate(a, b) {
  // console.log("Comparing:", a, b);
  const dateA = new Date(a.publishDate);
  const dateB = new Date(b.publishDate);
  if (isNaN(dateA) || isNaN(dateB)) return 0; // If invalid date, consider equal
  if (dateA > dateB) return -1; // Newest first
  if (dateA < dateB) return 1;
  return 0;
}

export default HomePage;
